import { Box, Typography } from "@mui/material";
import StringUtils from "../../Utils/StringUtils";
import MiscUtils from "../../Utils/MiscUtils";
import { makeStyles } from "@mui/styles";
import DOMPurify from "dompurify";

const useStyles = makeStyles({
  commentCardContainer: {
    background: "white",
    margin: "0 10px 14px 10px",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    borderRadius: "10px",
  },
  comment: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export default function CommentCard(props) {
  const styleClass = useStyles();
  const comment = props.comment;

  const isHTML = (text) => {
    const htmlPattern = /<([a-z][\w-]*)(?:[^>]*?)\/?>/gi;
    return htmlPattern.test(text);
  };

  const getCommentedBy = () => {
    if (comment.commentedBy === "ticketuser") {
      return "My Comment";
    }
    return comment.commentedBy;
  };

  const getSanitisedHtml = () => {
    return DOMPurify.sanitize(comment.comment);
  };

  return (
    <Box className={styleClass.commentCardContainer}>
      <Box className={styleClass.comment}>
        <Typography
          sx={{ color: "black", fontWeight: "600", fontSize: "14px" }}
        >
          {StringUtils.extractNameFromZammadSpecificString(getCommentedBy())}
        </Typography>
        <Typography sx={{ color: "#666666", fontSize: "12px" }}>
          {MiscUtils.getDateInFormat(comment.createdOn, "D MMM YYYY")}
        </Typography>
      </Box>
      {isHTML(comment.comment) ? (
        <div
          style={{ fontSize: "12px" }}
          className="comment"
          dangerouslySetInnerHTML={{ __html: getSanitisedHtml() }}
        ></div>
      ) : (
        <Typography sx={{ fontSize: "12px" }}>{comment.comment}</Typography>
      )}
    </Box>
  );
}
